(function(){
  function totals(price,compare,servings,quantity){
    const q=Math.max(1,Math.min(99,parseInt(quantity,10)||1));
    return {quantity:q,price:price*q,compare:compare*q,saving:Math.max(0,compare-price)*q,servings:servings*q};
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={totals};return;}
  const money=value=>new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(value/100);
  function render(card){
    const input=card.querySelector('[name="quantity"]');
    if(!input)return;
    const result=totals(Number(card.dataset.hsQuantityPrice),Number(card.dataset.hsQuantityCompare||0),Number(card.dataset.hsQuantityServings||0),input.value);
    const price=card.querySelector('.hc-prices strong'),compare=card.querySelector('.hc-prices s');
    const saving=card.querySelector('.hc-off--saving');
    const portions=card.querySelector('.hc-portions-text > span');
    if(price)price.textContent=money(result.price);
    if(compare)compare.textContent=money(result.compare);
    if(saving&&result.saving>0)saving.textContent='Economize '+money(result.saving);
    if(portions&&result.servings>0)portions.textContent=`Rende ${result.servings} ${result.servings===1?'porção':'porções'}`;
  }
  const selector='[data-hs-quantity-price]';
  function update(event){const card=event.target.closest(selector);if(card)setTimeout(()=>render(card),0);}
  document.addEventListener('input',event=>{if(event.target.matches('[name="quantity"]'))update(event);});
  document.addEventListener('change',event=>{if(event.target.matches('[name="quantity"]'))update(event);});
  document.addEventListener('click',event=>{if(event.target.closest('.hs-home-quantity button,[data-hc-step]'))update(event);});
  function init(){document.querySelectorAll(selector).forEach(render);}
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('DOMContentLoaded',init);
  if(document.readyState!=='loading')init();
})();
